import { render, staticRenderFns } from "./ManagerDashboardRecentPlacementsTableItem.vue?vue&type=template&id=55cceab8"
import script from "./ManagerDashboardRecentPlacementsTableItem.vue?vue&type=script&lang=js"
export * from "./ManagerDashboardRecentPlacementsTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports